import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useStore } from 'vuex';
import GettingStartedView from "./views/GettingStarted.vue"; 
import DashboardView from './views/DashboardView.vue';
import SearchOrdersView from './views/SearchOrdersView.vue';
import ManageOrderView from './views/ManageOrderView.vue';
import NewOrderView from './views/NewOrderView.vue';
import SearchUsersView from './views/SearchUsersView.vue';
import ManageUserView from './views/ManageUserView.vue';
import ManageCreditView from './views/ManageCreditView.vue';
import ManageFreeEntriesView from './views/ManageFreeEntriesView.vue';
import ViewCompetitionsView from './views/ViewCompetitionsView.vue';
import ViewCompetitionView from './views/ViewCompetitionView.vue';
import ViewReportsView from './views/ViewReportsView.vue';
import WinnersView from './views/WinnersView.vue';
import BonusWinnersView from './views/BonusWinnersView.vue';
import UserCapReportView from './views/UserCapReportView.vue';
import CreditAndEntriesView from './views/CreditAndEntriesView.vue';
import BulkCreditUploadView from './views/BulkCreditUploadView.vue';

import AuthenticationCallback from './views/AuthenticationCallback.vue';
import authenticationService from "../src/services/authentication-service";

const routes: Array<RouteRecordRaw> = [
    //{
    //   path: '/',
    //   name: 'login',
    //   component: GettingStartedView
    //},
    {
        path: '/auth/callback',
        name: 'callback',
        component: AuthenticationCallback
     },
    {
        path: '/',
        name: 'dashboard',
        component: DashboardView,
        meta: { requireAuth: true },
    },
    {
        path: '/orders/search',
        name: 'search-orders',
        component: SearchOrdersView,
        meta: { requireAuth: true },
    },
    {
        path: '/orders/:orderId',
        name: 'manage-order',
        component: ManageOrderView,
        meta: { requireAuth: true },
    },

    {
        path: '/orders/new',
        name: 'new-order',
        component: NewOrderView,
        meta: { requireAuth: true },
    },
    {
        path: '/users/search',
        name: 'users-search',
        component: SearchUsersView,
        meta: { requireAuth: true },
    },
    {
        path: '/users/:userId',
        name: 'manage-user',
        component: ManageUserView,
        meta: { requireAuth: true },
    },

    {
        path: '/users/:userId/free-entries',
        name: 'manage-free-entries',
        component: ManageCreditView,
        meta: { requireAuth: true },
    },
    {
        path: '/users/:userId/credit',
        name: 'manage-credit',
        component: ManageCreditView,
        meta: { requireAuth: true },
    },
    {
        path: '/competitions',
        name: '/competitions',
        component: ViewCompetitionsView,
        meta: { requireAuth: true },
    },
    {
        path: '/competitions/:competitionId',
        name: 'competition',
        component: ViewCompetitionView,
        meta: { requireAuth: true },
    },    
    {
        path: '/winners',
        name: 'winners',
        component: WinnersView,
        meta: { requireAuth: true },
    },
    {
        path: '/bonus-winners',
        name: 'bonus-winners',
        component: BonusWinnersView,
        meta: { requireAuth: true },
    },
    {
        path: '/credit-and-entries',
        name: 'credit-and-entries',
        component: CreditAndEntriesView,
        meta: { requireAuth: true },
    },
    {
        path: '/users/bulk-credit',
        name: 'bulk-credit',
        component: BulkCreditUploadView,
        meta: { requireAuth: true },
    },
    {
        path: '/reports',
        name: 'reports',
        component: ViewReportsView,
        meta: { requireAuth: true },
    },
    {
        path: '/reports/user-cap',
        name: 'user-cap-report',
        component: UserCapReportView,
        meta: { requireAuth: true },
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach(async (to, from, next) => {
    try {       
        document.title = 'WSP Admin';
        const store = useStore();
        const isAuthenticated = await authenticationService.isAuthenticated();
        store.dispatch('auth/setUserAuthenticationStatus', isAuthenticated);
        
        if (to.meta.requireAuth) {
            if (!isAuthenticated) {                
                await authenticationService.login();
                return;
            }else {
                next();
            }
        } else {
            next();
        }
    } catch (error) {
        console.error("Error during authentication check:", error);
        next(false);
    }
});

  

export default router
